<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar dark color="secondary" class="white--text" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title> Station Rates </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    color="primary"
                    @click="getNewRatesReport"
                >
                    Get NewRates Report
                    <v-icon
                        right
                        dark
                    >mdi-file-chart</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row class="mt-1">
                    <v-col cols="6">
                        <v-combobox
                            :items="stations"
                            :item-text="'Name'"
                            :item-value="'id'"
                            label="Look Up"
                            dense
                            class="mx-3 mt-3"
                            v-model="station"
                            @change="getRates()"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="5" style="margin: 0px; padding-top: 0px">
                        <v-simple-table
                            class="mx-3"
                            style="margin-top: 0px; padding-top: 0px"
                        >
                            <tr>
                                <th>Station</th>
                                <td width="80%">{{ station.Name }}</td>
                            </tr>
                            <tr>
                                <th>Address:</th>
                                <td width="80%" style="color: #01579b">
                                    {{ station.Address }}
                                </td>
                            </tr>
                            <tr>
                                <th>City:</th>
                                <td width="80%">{{ station.City }}</td>
                            </tr>
                        </v-simple-table>
                    </v-col>
                    <v-col>
                        <v-btn
                            class="mx-2 mt-2"
                            fab
                            dark
                            small
                            @click="addRow"
                            color="primary"
                            v-if="station.length != 0"
                        >
                            <v-icon dark> mdi-plus-circle </v-icon>
                        </v-btn>
                        <v-btn
                            class="mx-2 mt-2"
                            fab
                            dark
                            small
                            @click="saveData"
                            color="primary"
                            v-if="station.length != 0"
                        >
                            <v-icon dark> mdi-content-save </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row
                    style="margin-top: 0px; padding-top: 0px"
                    v-if="station.length != 0"
                >
                </v-row>
                <v-row style="margin-top: 0px; padding-top: 0px">
                    <v-col cols="4">
                        <v-toolbar dark color="primary" dense>
                            <v-spacer />
                            <v-toolbar-title class="white--text"
                                >TERMINALS</v-toolbar-title
                            >
                            <v-spacer />
                        </v-toolbar>
                        <v-simple-table dense>
                            <thead class="theadRate">
                                <tr>
                                    <th></th>
                                    <th>Terminal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in rate" :key="index">
                                    <td width="10%">
                                        <button
                                            icon
                                            small
                                            @click="deleteitemConfirm(item)"
                                        >
                                            <v-icon color="red"
                                                >mdi-delete</v-icon
                                            >
                                        </button>
                                    </td>
                                    <td class="rowRate">
                                        <v-combobox
                                            required
                                            dense
                                            hide-details
                                            v-model="item.terminal.TerminalName"
                                            :items="terminals"
                                            :item-text="'Name'"
                                            :item-value="'id'"
                                            auto-select-first
                                            @change="
                                                prepParams(
                                                    item,
                                                    'Terminal',
                                                    index
                                                )
                                            "
                                        ></v-combobox>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="4">
                        <v-toolbar dark color="primary" dense>
                            <v-spacer />
                            <v-toolbar-title class="white--text"
                                >INVOICING</v-toolbar-title
                            >
                            <v-spacer />
                        </v-toolbar>
                        <v-simple-table dense>
                            <thead class="theadRate">
                                <tr>
                                    <th width="20%">Dies Rate</th>
                                    <th width="20%">Gas Rate</th>
                                    <th width="20%">Flat Rate</th>
                                    <th width="20%">BH Rate</th>
                                    <th width="20%">BH Flat</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in rate" :key="index">
                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.InvRate"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'InvRate',
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.InvGasRate"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'InvGasRate',
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </td>

                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.InvFlat"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'InvFlat',
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </td>

                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.InvBHRate"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'InvBHRate',
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </td>

                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.InvBHFlat"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'InvBHFlat',
                                                    index
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="4">
                        <v-toolbar dark color="primary" dense>
                            <v-spacer />
                            <v-toolbar-title class="white--text"
                                >OO PAYROLL</v-toolbar-title
                            >
                            <v-spacer />
                        </v-toolbar>
                        <v-simple-table dense>
                            <thead class="theadRate">
                                <tr>
                                    <th>St Hours</th>
                                    <th>Kms</th>
                                    <th>OO GasRate</th>
                                    <th>OO DiesRate</th>
                                    <th>OO FlatRate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in rate" :key="index">
                                    <td class="rowRate">
                                        
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.StandardHours"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'StandardHours',
                                                    index.toString()
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.Kms"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'Kms',
                                                    index.toString()
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.OObyLitre"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'OObyLitre',
                                                    index.toString()
                                                )
                                            "
                                        ></v-text-field>
                                    </td>

                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.OObyLitreDiesel"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'OObyLitreDiesel',
                                                    index.toString()
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                    <td class="rowRate">
                                        <v-text-field
                                            dense
                                            hide-details
                                            v-model="item.PayFlatRate"
                                            prefix="$"
                                            @blur="
                                                prepParams(
                                                    item,
                                                    'PayFlatRate',
                                                    index.toString()
                                                )
                                            "
                                        ></v-text-field>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <dltDiaglog :dltData="parms" v-if="$store.state.delete" />

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
export default {
    directives: { mask },
    components: {
        ConfirmDialogue
    },
    data: function() {
        return {
            station: [],
            stations: [],
            terminal: [],
            terminals: [],
            rate: [],
            rateOrigin: [],
            arrs: [],
            parms: {},
            parmsData: {},
            indexFlag: null
        };
    },
    watch: {
        '$store.state.stationRate.watch': function() {
            if (this.$store.state.stationRate.watch == true) {
                this.getRates();
            }
        }
    },

    mounted() {
        this.loadTerminals();
        this.loadStations();
    },
    methods: {
        getNewRatesReport: async function () {
            console.log("getNewRatesReport");
            this.$store.state.isLoading = true;
            await axios
                .post('new-rate/report/general', '', {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    let fileName = 'NewRates.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        saveData: function() {
            var str = this.$store;
            console.log(Object.values(this.parms));
            this.$store.state.isLoading = true;
            if (this.parms.length != 0) {
                axios
                    .post('new-rate/save/changes', Object.values(this.parms), {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Save'
                        });
                        this.resetVariables();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        this.$store.state.isLoading = false;
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                            this.$store.state.isLoading = false;
                        }
                    });
            } else {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'There are no changes'
                });
            }
        },
        prepParams: function(prm, name, idx) {
            /*
                indexFlag : Funciona como bandera para saber de que fila se realizo el cambio 
                parmsData : Contiene los valor dependiendo la fila (indexFlag) 
                parms : Contiene todos los cambios realizados
                arrs : arreglo que guarda las filas donde ya se hizo cambios

                idx: index recibido
                name: nombre del parametro (Kms,OObyLitre,OObyLitreDiesel ...) recibido
                prm: valor parametro recibido 
            */
            if (this.indexFlag == null) {
                this.indexFlag = idx;
                this.arrs.push(idx);
                if (name == 'Terminal') {
                    this.parmsData[name] = prm.terminal.TerminalName.id;
                } else {
                    this.parmsData[name] = prm[name];
                }
                this.parms[idx] = this.parmsData;
                this.parmsData['RateId'] = prm['RateId'];
            } else if (this.indexFlag == idx) {
                if (name == 'Terminal') {
                    this.parmsData[name] = prm.terminal.TerminalName.id;
                } else {
                    this.parmsData[name] = prm[name];
                }
                this.parmsData['RateId'] = prm['RateId'];
                this.parms[idx] = this.parmsData;
            } else if (this.indexFlag != idx) {
                this.parmsData = {};
                var dx = this.arrs.find(x => {
                    return x === idx;
                });
                if (dx == undefined) {
                    this.arrs.push(idx);
                    if (name == 'Terminal') {
                        this.parmsData[name] = prm.terminal.TerminalName.id;
                    } else {
                        this.parmsData[name] = prm[name];
                    }
                    this.parmsData['RateId'] = prm['RateId'];
                    this.parms[idx] = this.parmsData;
                    this.indexFlag = idx;
                } else {
                    console.log(this.parms[dx]);
                    this.parmsData = this.parms[dx];
                    if (name == 'Terminal') {
                        this.parmsData[name] = prm.terminal.TerminalName.id;
                    } else {
                        this.parmsData[name] = prm[name];
                    }
                    this.parmsData['RateId'] = prm['RateId'];
                    this.parms[idx] = this.parmsData;
                    this.indexFlag = dx;
                }
            }
            console.log(this.parms);
        },

        addRow: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                Station: this.station.id
            };
            axios
                .post('new-rate', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.getRates();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        loadTerminals: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('terminal', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        updateTerminal: function(itm) {
            var str = this.$store;
            var parms = {
                Terminal: itm.terminal.TerminalName.id
            };
            console.log(parms);
            axios
                .put('new-rate/' + itm.RateId, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        resetVariables: function() {
            this.parms = {};
            this.parmsData = {};
            this.arrs = [];
            this.indexFlag = null;
        },

        async deleteitemConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this Rate',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteRate(itm.RateId);
            }
        },

        deleteRate: function(itm) {
            var str = this.$store;
            axios
                .delete('new-rate/' + itm, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete Rate successful.'
                    });
                    this.getRates();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        getRates: function() {
            if(this.station != null){
            var str = this.$store;
            str.state.isLoading = true;
            this.resetVariables();
            axios
                .get('new-rate/st/' + this.station.id, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.rate = response.data;
                    this.rateOrigin = response.data;
                    console.log(this.rate);
                    str.state.isLoading = false;

                    this.rate.forEach(element => {
                        if (element.Terminal == null || element.Terminal == 0) {
                            element.terminal = {
                                TerminalName: 'Select Terminal',
                                TerminaID: ''
                            };
                        }
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });

                        str.state.isLoading = false;
                    }
                });
            this.$store.state.isLoading = false;
            }
        },

        loadStations: function() {
            var str = this.$store;
            axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data.data);
                    this.stations = response.data.data;
                    this.stations.forEach(elm => {
                        elm.combox =
                            elm.Name + ' / ' + elm.Address + ' / ' + elm.City;
                    });
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        }
    }
};
</script>
<style>
tr:nth-of-type(odd) {
    background: #ebf3fd;
}
tr th {
    background-color: #adbbcc;
}
.rowRate {
    height: 0px;
}
.img-left {
    float: left;
    margin-left: 10px;
}
</style>
